<template>
  <el-dialog
    title="支付通道配置"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >



    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
              prop="userCode"
              label="支付方式"
      >
        <el-radio v-model="radio" label="0"  @change="changeHandler(0)">微信</el-radio>
        <el-radio v-model="radio" label="1"  @change="changeHandler(1)">支付宝</el-radio>
        <el-radio v-model="radio" label="2" @change="changeHandler(2)">乐刷</el-radio>
        <el-radio v-model="radio" label="3" @change="changeHandler(3)">随行付</el-radio>
        <el-radio v-model="radio" label="4" @change="changeHandler(4)">银盛</el-radio>
      </el-form-item>
      <el-form-item v-if="formEdit1"
                    label="抽佣比例"
      >
        <el-input-number v-model="form.num1" :min="0.00" :max="100" :step="0.01"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li  v-if="dl_type=='0'">全国代理的分佣比例，比如填写60%，则分商户流水佣金的60%给服务商</li>
          <li  v-if="dl_type=='1'">运营商的分佣比例，比如填写60%，则分商户流水佣金的60%给运营商</li>
          <li  v-if="dl_type=='2'">服务商的分佣比例，比如填写60%，则分商户流水佣金的60%给服务商</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit2"
                    label="抽佣比例"
      >
        <el-input-number v-model="form.num2" :min="0.00" :max="100" :step="0.01"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li  v-if="dl_type=='0'">全国代理的分佣比例，比如填写60%，则分商户流水佣金的60%给全国代理</li>
          <li  v-if="dl_type=='1'">运营商的分佣比例，比如填写60%，则分商户流水佣金的60%给运营商</li>
          <li  v-if="dl_type=='2'">服务商的分佣比例，比如填写60%，则分商户流水佣金的60%给服务商</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit3"
                    label="抽佣比例"
      >
        <el-input-number v-model="form.num3" :min="0.00" :max="100" :step="0.01"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li  v-if="dl_type=='0'">全国代理的分佣比例，比如填写60%，则分商户流水佣金的60%给全国代理</li>
          <li  v-if="dl_type=='1'">运营商的分佣比例，比如填写60%，则分商户流水佣金的60%给运营商</li>
          <li  v-if="dl_type=='2'">服务商的分佣比例，比如填写60%，则分商户流水佣金的60%给服务商</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit4"
                    label="抽佣比例"
      >
        <el-input-number v-model="form.num4" :min="0.00" :max="100" :step="0.01"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li  v-if="dl_type=='0'">全国代理的分佣比例，比如填写60%，则分商户流水佣金的60%给全国代理</li>
          <li  v-if="dl_type=='1'">运营商的分佣比例，比如填写60%，则分商户流水佣金的60%给运营商</li>
          <li  v-if="dl_type=='2'">服务商的分佣比例，比如填写60%，则分商户流水佣金的60%给服务商</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit5"
                    label="抽佣比例"
      >
        <el-input-number v-model="form.num5" :min="0.00" :max="100" :step="0.01"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li  v-if="dl_type=='0'">全国代理的分佣比例，比如填写60%，则分商户流水佣金的60%给全国代理</li>
          <li  v-if="dl_type=='1'">运营商的分佣比例，比如填写60%，则分商户流水佣金的60%给运营商</li>
          <li  v-if="dl_type=='2'">服务商的分佣比例，比如填写60%，则分商户流水佣金的60%给服务商</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>



      <el-form-item>


        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<style>

  .bg-purple-dark {
    background: #e5e9f2;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
export default {
  name: "payconfigureEditForm",
  props: {
      oneagent: Object,
      accuseVisible:Boolean,
    value: Boolean
  },
  data() {
    return {
        accuseVisible2:true,
      loading: false,
      dialogVisible: false,
        dl_type:'',
        radio: '0',
        formEdit1: true,
        formEdit2: false,
        formEdit3: false,
        formEdit4: false,
        formEdit5: false,
      form: {
          num1: '0.00',
          num2: '0.00',
          num3: '0.00',
          num4: '0.00',
          num5: '0.00'
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
      accuseVisible (newValue, oldValue) {
          console.log("-----"+newValue);
          this.accuseVisible2 = newValue;
      },
      handleClick(){

      },
      dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        this.dl_type=this.oneagent.dl_type;
        var formData2 = new FormData() // 声明一个FormData对象
        formData2.append('agentid',this.oneagent.agentid)
        agentService.getShareAgent(formData2).then(data => {
            if(data!=null && data!="") {
                this.form.num1=data.wx_num;
                this.form.num2=data.zfb_num;
                this.form.num3=data.fy_num;
                this.form.num4=data.sxf_num;
                this.form.num5=data.ys_num;
            }else{
                this.form.num1="0.00";
                this.form.num2="0.00";
                this.form.num3="0.00";
                this.form.num4="0.00";
                this.form.num5="0.00";
            }
        });

    },
      changeHandler(val){
          if(val==0) {
              this.formEdit1 = true;
              this.formEdit2 = false;
              this.formEdit3 = false;
              this.formEdit4 = false;
              this.formEdit5 = false;
          }else if(val==1){
              this.formEdit1 = false;
              this.formEdit2 = true;
              this.formEdit3 = false;
              this.formEdit4 = false;
              this.formEdit5 = false;
          }else if(val==2){
              this.formEdit1 = false;
              this.formEdit2 = false;
              this.formEdit3 = true;
              this.formEdit4 = false;
              this.formEdit5 = false;
          }else if(val==3){
              this.formEdit1 = false;
              this.formEdit2 = false;
              this.formEdit3 = false;
              this.formEdit4 = true;
              this.formEdit5 = false;
          }else if(val==4){
              this.formEdit1 = false;
              this.formEdit2 = false;
              this.formEdit3 = false;
              this.formEdit4 = false;
              this.formEdit5 = true;
          }
      },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            if (this.oneagent.agentid) {
                this.loading = true;
                agentService.saveShareAgent({ ...this.form,agentid:this.oneagent.agentid,dl_type:this.oneagent.dl_type})
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });
            }
        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

